import { z } from 'zod';

import { DOCUMENT_ID_LENGTH } from '../constants';
import { requiredApplicationIdString } from '../helper';

export const verifyIncomeDocumentUploadSchema = z.object({
  applicationId: requiredApplicationIdString(),
  documentIds: z
    .array(
      z.string().length(DOCUMENT_ID_LENGTH, `Document ID must be ${DOCUMENT_ID_LENGTH} characters long`),
    )
    .min(1, 'At least one document ID is required'),
});
